import { cva } from 'class-variance-authority';

export const container = cva(['flex flex-col gap-6 h-full w-full']);

export const title = cva([
  'text-2xl sm:whitespace-nowrap text-brand-800 font-semibold flex items-center flex-row gap-2',
]);
